import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { selectThirdPartyRole } from '@ruby/modules/third-party/store';
import { fromThirdPartyCore, ThirdPartyCoreActions } from '@ruby/modules/third-party/store/third-party-core.index';

@Component({
  selector: 'ng-third-party-header-container',
  template: `
    <ng-third-party-header *ngIf="(state$ | async) as store" [status]="store.core.status" [loading]="store.core.loading"
                           [has3PLRole]="store.has3PLRole"></ng-third-party-header>`
})
export class ThirdPartyHeaderContainerComponent implements OnInit {
  state$!: Observable<{ core: fromThirdPartyCore.State; has3PLRole?: boolean }>;

  constructor(private store: Store<fromThirdPartyCore.State>) {
    this.state$ = this.store.select(selectThirdPartyRole);
  }

  ngOnInit(): void {
    this.store.dispatch(ThirdPartyCoreActions.loadLOAStatus());
  }
}
